/*
 * @providesModule TextInputComponentStyle
 */

import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
    container: {
        alignItems: 'center',
        height: 60,
    },
    textInput: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        ...Platform.select({
            web: {
                width: '100%',
            }
        }),
    },
    inputContainer: {
        flex: 1,
        justifyContent: 'center',
        ...Platform.select({
            web: {
                height: "100%",
            }
        }),
    },
    input: {
        fontSize: 16,
        paddingHorizontal: 0,
        flex: 1,
        color: 'black',
        ...Platform.select({
            web: {
                height: "100%",
                outlineStyle: "none",
                zIndex: 1,
            }
        }),
    },
    label: {
        fontSize: 16,
    },
    row: {
        flexDirection: 'row',
    },
    icon: {
        width: 20,
        height: 20,
    },
    textError: {
        color: 'red',
        fontSize: 14,
        marginTop: 10,
    },
    selectedItem: {
        height: 30,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 0.5,
        borderColor: 'gray',
        paddingHorizontal: 8,
        marginTop: 12,
        marginRight: 8,
        flexDirection: 'row'
    },
    selectedTextItem: {
        marginLeft: 5,
        color: 'gray',
        fontSize: 16
    },
});
